import { render, staticRenderFns } from "./head.vue?vue&type=template&id=5864f244&scoped=true"
import script from "./head.vue?vue&type=script&lang=js"
export * from "./head.vue?vue&type=script&lang=js"
import style0 from "./head.vue?vue&type=style&index=0&id=5864f244&prod&lang=scss&scoped=true"
import style1 from "./head.vue?vue&type=style&index=1&id=5864f244&prod&lang=scss&scoped=true"
import style2 from "./head.vue?vue&type=style&index=2&id=5864f244&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5864f244",
  null
  
)

export default component.exports